import React, { PureComponent } from 'react'
import { string, arrayOf, element } from 'prop-types'
import { findIndex } from 'lodash'
import './SectionCards.css'


export class SectionAllCards extends PureComponent {
    static propTypes = {
        groupIds: arrayOf(string).isRequired,
        selectedGroupId: string,
        children: arrayOf(element).isRequired
    }

    componentWillMount() {
        this.refreshSelectedIndex(this.props)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.selectedGroupId !== this.props.selectedGroupId) {
            this.refreshSelectedIndex(nextProps)
        }
    }
    refreshSelectedIndex = props => {
        const { groupIds, selectedGroupId } = props
        this.selectedIndex = findIndex(groupIds, id => id === selectedGroupId)
    }

    renderChild = (child, index) => {
        const hideAll = this.selectedIndex === -1
        return (
            <section key={index} className={['Cards', { Hide: hideAll }]} style={{ transform: `translateX(${(index - this.selectedIndex) * 100}vw)` }}>
                {child}
            </section>
        )
    }

    render() {
        const { children } = this.props
        return children.map(this.renderChild)
    }
}



// WEBPACK FOOTER //
// src/components/Sections/Cards/SectionAllCards.js